module.exports = __webpack_public_path__ + "media/images/bondform_bearhead4-f5da5a42691e75815de833ede7806d1c.gif";